import { ArrowRightStartOnRectangleIcon, BanknotesIcon, KeyIcon, WrenchScrewdriverIcon } from "@heroicons/react/24/outline";

export const getUserMenuData = ({ user, workspaceDetails, overflowedHeaderMenus, setIsOpenModal, logout, UserImage, switchAdminButtonDisabled, onHandleSwitchToAdmin, navigateToPaymemnts }) => {
  const userBlock =
    workspaceDetails?.notification_banner_enable || window.innerWidth < 700
      ? [
          {
            _id: user?.name,
            image: user?.image || UserImage,
            label: user?.name || "User",
            standout: false,
            type: "user",
          },
          { _id: "divider", type: "divider" },
        ]
      : [];

  const divider = overflowedHeaderMenus?.length ? [{ _id: "header-menus", label: "Header Menus", standout: false, type: "label" }] : [];

  const overflowItems =
    overflowedHeaderMenus?.map((item, idx) => ({
      _id: `overflow-${idx}`,
      slug: item.slug || item._id,
      label: item.name,
      icon: item.image
        ? () => (
            <span
              className="h-4 w-4"
              dangerouslySetInnerHTML={{
                __html: item.image?.replace(/stroke-width="[^"]*"/g, 'stroke-width="1.5"').replace(/stroke="[^"]*"/g, 'stroke="currentColor"'),
              }}
            />
          )
        : null,
      standout: false,
      link: item.link,
    })) || [];

  const actionDivider = overflowedHeaderMenus?.length
    ? [
        { _id: "divider-2", type: "divider" },
        { _id: user?.name, label: "Actions", standout: false, type: "label" },
      ]
    : [];

  const staticItems = [
    {
      _id: "change-password",
      icon: KeyIcon,
      label: "Change password",
      standout: false,
      onclick: () => setIsOpenModal(true),
    },
    {
      _id: 3,
      icon: WrenchScrewdriverIcon,
      label: "Switch to Admin",
      disabled: switchAdminButtonDisabled,
      standout: false,
      hidden: !["admin", "editor"].includes(user?.type),
      onclick: onHandleSwitchToAdmin,
    },
    {
      _id: 4,
      icon: BanknotesIcon,
      label: "Manage Payments",
      standout: false,
      hidden: !(workspaceDetails?.billing_elegible_user_id === user?._id),
      onclick: navigateToPaymemnts,
    },
    {
      _id: "Logout",
      icon: ArrowRightStartOnRectangleIcon,
      label: "Logout",
      onclick: logout,
      standout: false,
    },
  ];

  return [...userBlock, ...divider, ...overflowItems, ...actionDivider, ...staticItems];
};
